import React, { Component } from 'react';
import './Upper.css';
import sunLogo from './icon-sun.png';
import moonLogo from './icon-moon.png';
import desktopDarkImage from './bg-desktop-dark.jpg';
import desktopLightImage from './bg-desktop-light.jpg';
class Upper extends Component{
    constructor(props){
        super(props);
        this.state = {
            darkTheme : true
        }
        this.handleTheme = this.handleTheme.bind(this);
    }
    handleTheme(evt){
        evt.preventDefault();
        this.props.handleTheme();
    }
    render(){
        return(
            <div className='UpperDiv' style=
                {{background : this.props.darkTheme ? 
                    `url(${desktopDarkImage}) no-repeat center center/cover`
                    :
                    `url(${desktopLightImage}) no-repeat center center/cover`
                }}
                >
                <div className = 'heading'>
                    <h1 style={{letterSpacing : '7px'}}>TODO</h1>
                    {this.props.darkTheme ? 
                        <img src= {sunLogo} alt = {sunLogo} onClick = {this.handleTheme}/>
                        :
                        <img src = {moonLogo} alt = {moonLogo} onClick = {this.handleTheme}/>
                    } 
                    
                </div>
            </div>
        )
    }
}

export default Upper;